import styled from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';
import text from '@polyai/ui/styles/config/text';

export const AddButton = styled.button`
  position: absolute;
  top: 2px;
  right: 25px;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
`;

export const ShortcutHint = styled.span`
  font-weight: ${text.weight.semibold};
  color: ${themeColors.textHelper};
`;
